const channelColors = Object.freeze({
	1: {},
	2: {
		'ARO SPONT': '#b5c4f0'
	},
	3: {},
	4: {},
	5: {},
	6: {},
	7: {},
	8: {},
	9: {},
	10: {},
	11: {},
	12: {
		'Obstructive Apnea': '#bf8975',
		'Central Apnea': '#ff7a7a',
		'Mixed Apnea': '#292e34',
		'Obstructive Hypopnea': '#c4e2e2',
		'Central Hypopnea': '#343961',
		'Mixed Hypopnea':'#ffb9b9',
		'Unsure Respiratory Event': '#ff4719',
		'Respiratory Artifact': '#ffdab9',
		'Respiratory Paradox': '#90251d',
		'Cheyne Stokes Breathing': '#e3a624',
		'RERA': '#1c2039'
	},
	13: {
		'Obstructive Apnea': '#bf8975',
		'Central Apnea': '#ff7a7a',
		'Mixed Apnea': '#292e34',
		'Obstructive Hypopnea': '#c4e2e2',
		'Central Hypopnea': '#343961',
		'Mixed Hypopnea':'#ffb9b9',
		'Unsure Respiratory Event': '#ff4719',
		'Respiratory Artifact': '#ffdab9',
		'Respiratory Paradox': '#90251d',
		'Cheyne Stokes Breathing': '#e3a624',
		'RERA': '#1c2039'
	},
	14: {
		'Obstructive Apnea': '#bf8975',
		'Central Apnea': '#ff7a7a',
		'Mixed Apnea': '#292e34',
		'Obstructive Hypopnea': '#c4e2e2',
		'Central Hypopnea': '#343961',
		'Mixed Hypopnea':'#ffb9b9',
		'Unsure Respiratory Event': '#ff4719',
		'Respiratory Artifact': '#ffdab9',
		'Respiratory Paradox': '#90251d',
		'Cheyne Stokes Breathing': '#e3a624',
		'RERA': '#1c2039'
	},
	15: {
		'Obstructive Apnea': '#bf8975',
		'Central Apnea': '#ff7a7a',
		'Mixed Apnea': '#292e34',
		'Obstructive Hypopnea': '#c4e2e2',
		'Central Hypopnea': '#343961',
		'Mixed Hypopnea':'#ffb9b9',
		'Unsure Respiratory Event': '#ff4719',
		'Respiratory Artifact': '#ffdab9',
		'Respiratory Paradox': '#90251d',
		'Cheyne Stokes Breathing': '#e3a624',
		'RERA': '#1c2039'
	},
	16: {
		'SpO2 Desat': '#71c3fa',
		'SpO2 Artifact': '#e88db7'
	},
	17: {
		'Limb movement (Left)': '#e88db7'
	},
	18: {
		'Limb movement (Right)': '#e88db7'
	},
	19: {},
	20: {},
})

export default channelColors